import Header from './Header';
import Authorization from './Authorization';

function DefaultLayout() {
  return (
    <div>
        <Header />
        <Authorization />
    </div>
  );
}

export default DefaultLayout;